import { render, staticRenderFns } from "./boletimTurma.vue?vue&type=template&id=6669e6b2&"
import script from "./boletimTurma.vue?vue&type=script&lang=js&"
export * from "./boletimTurma.vue?vue&type=script&lang=js&"
import style0 from "./boletimTurma.vue?vue&type=style&index=0&id=6669e6b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports